import React from 'react';
import { Mail, Linkedin, Github } from 'lucide-react';

export default function Footer() {
    return (
        <footer className="bg-blue-900 text-white py-8 mt-16">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    {/* Left: Identity */}
                    <div className="flex items-center mb-6 md:mb-0">
                        <img src="/IITHLogo.png" alt="IITH Logo" className="h-12 mr-4" />
                        <div>
                            <h3 className="text-xl font-bold">Kritik Agarwal</h3>
                            <p className="text-sm">M.Tech Computer Science & Engineering - TA</p>
                            <p className="text-sm">Indian Institute of Technology Hyderabad</p>
                        </div>
                    </div>
                    

                    {/* Right: Social Links */}
                    <div className="flex space-x-4 footer-icons">
                        <a
                            href="mailto:kritikagarwal@ymail.com"
                            className="bg-white text-blue-800 p-2 rounded-full hover:bg-blue-100 transition"
                            aria-label="Email"
                        >
                            <Mail size={20} />
                        </a>
                        <a
                            href="https://in.linkedin.com/in/agarwalkritik"
                            target="_blank" rel="noopener noreferrer"
                            className="bg-white text-blue-800 p-2 rounded-full hover:bg-blue-100 transition"
                            aria-label="LinkedIn"
                        >
                            <Linkedin size={20} />
                        </a>
                        <a
                            href="https://github.com/AgarwalKritik"
                            target="_blank" rel="noopener noreferrer"
                            className="bg-white text-blue-800 p-2 rounded-full hover:bg-blue-100 transition"
                            aria-label="GitHub"
                        >
                            <Github size={20} />
                        </a>
                    </div>
                </div>

                {/* Bottom Note */}
                <div className="text-center mt-8 text-sm text-gray-300">
                    <p>© 2025 Kritik Agarwal. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}
